import React, { useState, useEffect } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Button,
	Grid,
	Dialog,
	DialogTitle,
	DialogActions,
	DialogContent,
	DialogContentText,
	Divider,
	TextField,
	FormControl,
	Radio,
	RadioGroup,
	FormControlLabel,
} from "@material-ui/core";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { DownloadOutlined, WindowsFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import HttpService from "../../services/httpService";
import DataGridComponent from "../../components/DataGridComponent";
import { useSelector } from "react-redux";
import { ROLENAME } from "../../utils";

const useStyles = makeStyles((theme) => ({
	table: {
		minWidth: 850,
	},
	textField: {
		width: 100,
	},
	paper: {
		padding: theme.spacing(2),
		margin: "auto",
		maxWidth: 400,
	},
}));

const StyledTableCell = withStyles((theme) => ({
	head: {
		// backgroundColor: "#2C2E3E",
		backgroundColor: "#3F51B5",
		color: "#FFF",
		fontWeight: "500",
		// border: '1px solid black'
	},
	body: {
		fontSize: 14,
		// border: '1px solid red'
	},
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
	root: {
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);

const PaymentRequestApproval = (props) => {
	const classes = useStyles();
	const [
		dataForInwardingPaymentApproval,
		setDataForInwardingPaymentApproval,
	] = useState([]);
	const [selectedItemsForPayment, setSelectedItemsForPayment] = useState([]);
	const [showRaisedPaymentRequestModal, setShowRaisedPaymentRequestModal] =
		useState(false);
	const [grandTotalOfRaisedRequest, setGrandTotalOfRaisedRequest] =
		useState(0);
	const [openRemarksModal, setOpenRemarksModal] = useState(false);
	const [grandTotalOfFreight, setGrandTotalOfFreight] = useState(0);
	const [details, setDetails] = useState("");
	const [textContent, setTextContent] = useState("");
	const [value, setValue] = useState("");
	const [remarks, setRemarks] = useState("");
	const [isUserFinanceManager, setIsUserFinanceManager] = useState(false);
	const [paymentStatusRadioValue, setPaymentStatusRadioValue] = useState(
		"Finance Approved & Inwarded"
	);
	const { userDetails } = useSelector((state) => state.user);
	const [
		openRemarksModalForSingleInwarding,
		setOpenRemarksModalForSingleInwarding,
	] = useState(false);
	const [
		inwardingRecordIdForSingleInwarding,
		setInwardingRecordIdForSingleInwarding,
	] = useState(false);
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");

	// Function to get inwarding approved by finance to Raise Payment Requests
	const fetchInwardingPaymentRequest = async (startDate, endDate) => {
		props.setLoading(true);
		try {
			let payload = { startDate, endDate };
			const response = await HttpService.fetchInwardingPaymentRequest(
				payload
			);
			let resData = [];
			setDataForInwardingPaymentApproval(response.data);
			// setDataToDisplay(response.data);
		} catch (error) {
			console.error("Error -> ", error);
			props.setSnackInfo(
				error?.response?.data ?? "Something went wrong",
				"error"
			);
		}
		props.setLoading(false);
	};

	// Function to handle the raise payment request action
	const raisePaymentRequestHandler = async () => {
		props.setLoading(true);
		try {
			if (remarks.trim().length === 0) {
				// props.setSnackInfo("Please enter remarks before submitting.", "warning");
				props.setSnackInfo(
					`Please Enter ${textContent} Remarks Before Submitting`,
					"warning"
				);
				props.setLoading(false);
				return;
			}
			let payload = {
				status: value,
				remarks,
				inwardingPaymentApprovalId: details._id,
			};
			const response = await HttpService.handlePaymentRequestApproval(
				payload
			);
			
			props.setSnackInfo(
				response?.data?.msg ?? "Updated Successfully",
				response?.data?.type ?? "success"
			);
			// props.setSnackInfo("Inwarding Payment Approved Successfully", "success");
		} catch (error) {
			console.error("Error-- ", error);
		}
		setOpenRemarksModal(false);
		setShowRaisedPaymentRequestModal(false);
		setRemarks("");
		props.setLoading(false);
		fetchInwardingPaymentRequest("", "");
		// window.location.reload();
	};

	// Function to Open Remarks Modal
	const openRemarksModalHandler = (status) => {
		if (status === "Approved") {
			setTextContent("Approval");
		}
		if (status === "Rejected") {
			setTextContent("Rejection");
		}
		setValue(status);
		setOpenRemarksModal(true);
	};

	// Function to Open Remarks Modal For Single Inwarding
	const openRemarksModalHandlerForSingleInwarding = (status, value) => {
		setInwardingRecordIdForSingleInwarding(value.InwardingRecords._id);
		if (status === "Approved") {
			setTextContent("Approval");
		}
		if (status === "Rejected") {
			setTextContent("Rejection");
		}
		setValue(status);
		setOpenRemarksModalForSingleInwarding(true);
	};

	// Funtion to close Remarks Modal
	const closeRemarksModalHandler = () => {
		setOpenRemarksModal(false);
		setRemarks("");
	};

	// Funtion to close Remarks Modal For Single Inwarding
	const closeRemarksModalHandlerForSingleInwarding = () => {
		setOpenRemarksModalForSingleInwarding(false);
		setRemarks("");
	};

	// Function to handle remarks input
	const remarksInputHandler = async (e) => {
		setRemarks(e.target.value);
		// if (e.target.value.trim() === "") return props.setSnackInfo("Please Enter Remarks", "error");
	};

	// Function to handle opening of details of Inwarding Payment
	const openDetailsOfInwardingPaymentHandler = async (value) => {
		setDetails(value);
		// Step 1: Filter the array
		let filteredArray = value.inwardingRecordIds.filter(
			(el) => el.InwardingRecords.status === paymentStatusRadioValue
		);

		// Step 2: Sort the filtered array (assuming you want to sort by a specific property, e.g., 'vendorDetails.name')
		filteredArray.sort((a, b) => {
			if (a.vendorDetails.name < b.vendorDetails.name) return -1;
			if (a.vendorDetails.name > b.vendorDetails.name) return 1;
			return 0;
		});
		
		setSelectedItemsForPayment(filteredArray);
		const total = filteredArray.reduce(
			(acc, el) => acc + +el.InwardingRecords?.inwardedValueWithGST,
			0
		);
		const totalFreight = filteredArray.reduce(
			(acc, el) => acc + (+el?.InwardingRecords?.freightCharge || 0),
			0
		);
		
		setGrandTotalOfRaisedRequest(total);
		setGrandTotalOfFreight(totalFreight);
		// setGrandTotalOfFreight(value.freight);
		// setGrandTotalOfRaisedRequest(value.amount);
		setShowRaisedPaymentRequestModal(true);
		// if (e.target.value.trim() === "") return props.setSnackInfo("Please Enter Remarks", "error");
	};

	/**
	 * Function to handle single Inwarding payment.
	 *
	 * @param {string} action - The action to be taken for the payment request.
	 * @param {object} detail - The details of the payment request.
	 */
	const handleSingleInwardingPayment = async () => {
		props.setLoading(true);
		try {
			if (remarks.trim().length === 0) {
				// props.setSnackInfo("Please enter remarks before submitting.", "warning");
				props.setSnackInfo(
					`Please Enter ${textContent} Remarks Before Submitting`,
					"warning"
				);
				props.setLoading(false);
				return;
			}

			// Create a payload object with the status and data
			let payload = {
				status: value,
				inwardingRecordId: inwardingRecordIdForSingleInwarding,
                inwardingPaymentApprovalId: details._id,
				remarks: remarks,
			};

			// Make an asynchronous call to handle the payment request approval
			const response =
				await HttpService.handlePaymentRequestApprovalForSingleInwarding(
					payload
				);

			const response2 =
				await HttpService.fetchInwardingPaymentRequestById(details._id);
			
			openDetailsOfInwardingPaymentHandler(response2.data[0]);

			// Set a snackbar message to inform the user about the status of the request
			props.setSnackInfo(
				response?.data?.msg ?? "Updated Successfully",
				response?.data?.type ?? "success"
			);
		} catch (error) {
			// Log any errors that occur during the process
			console.error("Error -> ", error);
		}
		props.setLoading(false);
		// setShowRaisedPaymentRequestModal(false);
		setRemarks("");
		setOpenRemarksModalForSingleInwarding(false);
		// fetchInwardingPaymentRequest();
	};

	// Handle Radio change for approved/pending/rejected payment requests
	const handleRadioChange = (event) => {
		try {
			setPaymentStatusRadioValue(event.target.value);

			// Step 1: Filter the array
			let filteredArray = details.inwardingRecordIds.filter(
				(el) => el?.InwardingRecords?.status === event?.target?.value
			);

			// Step 2: Sort the filtered array (assuming you want to sort by a specific property, e.g., 'vendorDetails.name')
			filteredArray.sort((a, b) => {
				if (a.vendorDetails.name < b.vendorDetails.name) return -1;
				if (a.vendorDetails.name > b.vendorDetails.name) return 1;
				return 0;
			});
			const total = filteredArray.reduce(
				(acc, el) => acc + +el?.InwardingRecords?.inwardedValueWithGST,
				0
			);
			const totalFreight = filteredArray.reduce(
				(acc, el) => acc + (+el?.InwardingRecords?.freightCharge || 0),
				0
			);
			setGrandTotalOfRaisedRequest(total);
			setGrandTotalOfFreight(totalFreight);
			setSelectedItemsForPayment(filteredArray);
		} catch (error) {
			console.error("Error -> ", error);
		}
	};

	// Close Payment request summary page
	const closePaymentRequestSummaryPageHandler = () => {
		try {
			setShowRaisedPaymentRequestModal(false);
			setPaymentStatusRadioValue("Finance Approved & Inwarded");
			fetchInwardingPaymentRequest("", "");
		} catch (error) {
			console.error("Error -> ", error);
		}
	};

	// filter function for date range
	const inwardingPaymentRequestOnSelectedDateHandler = () => {
		fetchInwardingPaymentRequest(startDate, endDate);
	};

	// function to clear date filter
	const clearFilterDate = (e) => {
		setStartDate("");
		setEndDate("");
		fetchInwardingPaymentRequest("", "");
	};

	useEffect(() => {
		fetchInwardingPaymentRequest("", "");
		if (
			userDetails.roles.find(
				(role) => role.name === ROLENAME.FinanceManager
			)
		) {
			setIsUserFinanceManager(true);
		}
	}, []);

	return (
		<div>
			<div
				style={{
					marginBottom: 20,
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Paper className={classes.paper}>
					<center>
						<h2>Payment Request Approval</h2>
					</center>
				</Paper>
			</div>

			{/* Date Filter component */}
			<Paper style={{ padding: 10, marginBottom: 10 }}>
				<Grid
					container
					style={{ display: "flex", alignItems: "center" }}
				>
					<Grid
						item
						md={3}
						xs={12}
					>
						<TextField
							id="date"
							name="startDate"
							label="From Requested Date"
							type="date"
							value={startDate}
							onChange={(e) => setStartDate(e.target.value)}
							InputLabelProps={{
								shrink: true,
							}}
							fullWidth
							// className={classes.textField}
						/>
					</Grid>
					<Grid
						item
						md={1}
						xs={12}
					></Grid>
					<Grid
						item
						md={3}
						xs={12}
					>
						<TextField
							id="date"
							name="endDate"
							label="To Requested Date"
							type="date"
							value={endDate}
							onChange={(e) => setEndDate(e.target.value)}
							InputLabelProps={{
								shrink: true,
							}}
							fullWidth
							// className={classes.textField}
						/>
					</Grid>
					<Grid
						item
						md={3}
						xs={12}
					>
						<Button
							variant="contained"
							color="primary"
							// disabled={!startDate || !endDate}
							onClick={
								inwardingPaymentRequestOnSelectedDateHandler
							}
							style={{ marginLeft: 10 }}
						>
							Submit
						</Button>
					</Grid>
					<Grid
						item
						md={2}
						xs={12}
					>
						<Button
							variant="contained"
							color="secondary"
							onClick={clearFilterDate}
						>
							Clear Filter
						</Button>
					</Grid>
				</Grid>
			</Paper>

			{/*
            {dataForRaisingPaymentRequest.map((el, i) => {
                return (
                    <DataGridComponent
                        key={i + 1}
                        INWARDING_RECORD_ARRAY={el.InwardingRecordArr}
                        COLUMNS={columns}
                        ORDER_ID={el.orderId}
                        VENDOR_NAME={el.vendorName}
                        PAGE_SIZE={el.InwardingRecordArr.length}
                        HANDLE_SELECTED_INWARDING_CHANGE={
                            handleSelectedInwardingChange
                        }
                    />
                );
            })}
            */}

			{/* Data Displaying in Table */}
			{dataForInwardingPaymentApproval.length > 0 ? (
				<TableContainer
					TableContainer
					component={Paper}
				>
					<Table
						className={classes.table}
						size="small"
						aria-label="customized table"
						stickyHeader
					>
						<TableHead>
							<StyledTableRow>
								<StyledTableCell>Sl No</StyledTableCell>
								<StyledTableCell>Status</StyledTableCell>
								<StyledTableCell>Requested By</StyledTableCell>
								<StyledTableCell>Requested At</StyledTableCell>
								<StyledTableCell>Amount</StyledTableCell>
								<StyledTableCell>Freight</StyledTableCell>
								<StyledTableCell>Total Amount</StyledTableCell>
								<StyledTableCell>Action</StyledTableCell>
							</StyledTableRow>
						</TableHead>
						<TableBody>
							{dataForInwardingPaymentApproval?.map((el, i) => {
								return (
									<StyledTableRow key={i + 1}>
										<StyledTableCell>
											{i + 1}
										</StyledTableCell>
										<StyledTableCell>
											{el?.status}
										</StyledTableCell>
										<StyledTableCell>
											{el?.createdBy?.name}
										</StyledTableCell>
										<StyledTableCell>
											{moment(el?.createdAt).format(
												"DD-MM-YYYY"
											)}
										</StyledTableCell>
										<StyledTableCell>
											{el?.amount?.toFixed(2)}
										</StyledTableCell>
										<StyledTableCell>
											{el?.freight?.toFixed(2)}
										</StyledTableCell>
										<StyledTableCell>
											{el?.totalAmount?.toFixed(2)}
										</StyledTableCell>
										<StyledTableCell>
											<>
												<Button
													variant="contained"
													color="primary"
													onClick={() =>
														openDetailsOfInwardingPaymentHandler(
															el
														)
													}
												>
													{isUserFinanceManager
														? "Action"
														: "View"}
												</Button>
											</>
										</StyledTableCell>
									</StyledTableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<p style={{ color: "red" }}>
					<b>No Data To Show</b>
				</p>
			)}

			{/* Payment Request Summary */}
			<Modal
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
				title={`Payment Request Summary`}
				centered
				open={showRaisedPaymentRequestModal}
				onCancel={closePaymentRequestSummaryPageHandler}
				width={1500}
				maskClosable={true}
				footer={null}
			>
				<FormControl
					component="fieldset"
					className={classes.root}
				>
					<RadioGroup
						aria-label="type"
						name="type"
						value={paymentStatusRadioValue}
						onChange={handleRadioChange}
					>
						<div className="modal-header-radio">
							{/*
                            <FormControlLabel value="Pending" control={<Radio />} label="Pending" />
							<FormControlLabel value="Approved" control={<Radio />} label="Approved" />
							<FormControlLabel value="Rejected" control={<Radio />} label="Rejected" />
                            */}
							<FormControlLabel
								value="Finance Approved & Inwarded"
								control={<Radio />}
								label="Pending"
							/>
							<FormControlLabel
								value="Payment Approved"
								control={<Radio />}
								label="Approved"
							/>
							<FormControlLabel
								value="Sent For Finance Approval"
								control={<Radio />}
								label="Rejected"
							/>
						</div>
					</RadioGroup>
				</FormControl>
				<div style={{ display: "flex", width: "100%" }}>
					<Table
						size="small"
						aria-label="custom pagination table"
						className={classes.table}
					>
						<TableHead>
							<StyledTableRow>
								<StyledTableCell>SL No</StyledTableCell>
								<StyledTableCell>Vendor’s Name</StyledTableCell>
								<StyledTableCell>Inwarding Id</StyledTableCell>
								<StyledTableCell>Invoice No.</StyledTableCell>
								<StyledTableCell>
									Material’s Name
								</StyledTableCell>
								<StyledTableCell>
									In-warded Date
								</StyledTableCell>
								<StyledTableCell>
									Amount (With GST)
								</StyledTableCell>
								<StyledTableCell>Freight</StyledTableCell>
								{isUserFinanceManager ? (
									<StyledTableCell>Action</StyledTableCell>
								) : (
									""
								)}
							</StyledTableRow>
						</TableHead>

						<TableBody>
							{selectedItemsForPayment?.map((item, index) => (
								<StyledTableRow key={index}>
									<StyledTableCell>
										{index + 1}
									</StyledTableCell>
									<StyledTableCell>
										{item?.vendorDetails?.name}
									</StyledTableCell>
									<StyledTableCell>
                                        {item?.InwardingRecords?.inwardingId}
									</StyledTableCell>
									<StyledTableCell>
										{item?.InwardingRecords?.invoiceNumber}
									</StyledTableCell>
									<StyledTableCell>
										{item?.materialDetails?.name}
									</StyledTableCell>
									<StyledTableCell>
										{moment(
											item?.InwardingRecords
												?.dateOfInwarded
										).format("DD-MM-YYYY")}
									</StyledTableCell>
									<StyledTableCell>
										{(
											item?.InwardingRecords
												?.inwardedValueWithGST || 0
										)?.toFixed(2)}
									</StyledTableCell>
									<StyledTableCell>
										{(
											item?.InwardingRecords
												?.freightCharge || 0
										)?.toFixed(2)}
									</StyledTableCell>
									{isUserFinanceManager ? (
										<StyledTableCell>
											<div
												style={{
													display: "flex",
													width: "100%",
												}}
											>
												<div
													style={{
														flex: 1,
														padding: "1px",
													}}
												>
													<Button
														onClick={() =>
															openRemarksModalHandlerForSingleInwarding(
																"Approved",
																item
															)
														}
														variant="contained"
														size="small"
														style={{
															background:
																"#2b7636",
														}}
														disabled={
															item
																.InwardingRecords
																.status ===
																"Payment Approved" ||
															item
																.InwardingRecords
																.status ===
																"Sent For Finance Approval"
														}
													>
														Approve
													</Button>
												</div>
												<div
													style={{
														flex: 1,
														padding: "1px",
													}}
												>
													<Button
														onClick={() =>
															openRemarksModalHandlerForSingleInwarding(
																"Rejected",
																item
															)
														}
														color="secondary"
														variant="outlined"
														size="small"
														disabled={
															item
																.InwardingRecords
																.status ===
																"Payment Approved" ||
															item
																.InwardingRecords
																.status ===
																"Sent For Finance Approval"
														}
													>
														Reject
													</Button>
												</div>
											</div>
										</StyledTableCell>
									) : (
										""
									)}
								</StyledTableRow>
							))}
							<StyledTableRow key={"Total Amount"}>
								<StyledTableCell colSpan={2}></StyledTableCell>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell>
									<b>
										{grandTotalOfRaisedRequest?.toFixed(2)}
									</b>
								</StyledTableCell>
								<StyledTableCell>
									<b>{grandTotalOfFreight?.toFixed(2)}</b>
								</StyledTableCell>
								<StyledTableCell></StyledTableCell>
							</StyledTableRow>
							<StyledTableRow key={"Grand Total Amount"}>
								<StyledTableCell colSpan={2}>
									<b>Total Amount</b>
								</StyledTableCell>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell></StyledTableCell>
								<StyledTableCell>
									<b>
										{(
											grandTotalOfRaisedRequest +
											grandTotalOfFreight
										).toFixed(2)}
									</b>
								</StyledTableCell>
								<StyledTableCell></StyledTableCell>
							</StyledTableRow>
						</TableBody>
					</Table>
				</div>

				{isUserFinanceManager &&
				paymentStatusRadioValue === "Finance Approved & Inwarded" ? (
					<DialogActions>
						<Button
							onClick={() => openRemarksModalHandler("Rejected")}
							color="secondary"
							variant="outlined"
						>
							Reject
						</Button>
						<Button
							onClick={() => openRemarksModalHandler("Approved")}
							color="primary"
							variant="contained"
							style={{ background: "#2b7636", margin: 5 }}
						>
							Approve
						</Button>
					</DialogActions>
				) : (
					""
				)}
			</Modal>

			{/* Payment Raised Request Approval Confirmation Dialog Box */}
			<div>
				<Dialog
					open={openRemarksModal}
					onClose={closeRemarksModalHandler}
					aria-labelledby="form-dialog-title"
					maxWidth="sm"
					fullWidth
				>
					<DialogContent>
						<DialogContentText>
							Enter {textContent} Remarks
						</DialogContentText>
						<TextField
							id="remarks"
							name="Remarks"
							label="Add Remarks"
							variant="outlined"
							type="text"
							value={remarks}
							onChange={remarksInputHandler}
							fullWidth
						/>
					</DialogContent>
					<DialogActions>
						<Button
							variant="outlined"
							onClick={closeRemarksModalHandler}
							color="secondary"
						>
							Cancel
						</Button>
						<Button
							onClick={raisePaymentRequestHandler}
							variant="contained"
							color="primary"
							style={{ background: "#2b7636", margin: 5 }}
						>
							Submit
						</Button>
					</DialogActions>
				</Dialog>
			</div>

			{/* Payment Raised Request Approval Confirmation Dialog Box For Single Inwarding */}
			<div>
				<Dialog
					open={openRemarksModalForSingleInwarding}
					onClose={closeRemarksModalHandlerForSingleInwarding}
					aria-labelledby="form-dialog-title"
					maxWidth="sm"
					fullWidth
				>
					<DialogContent>
						<DialogContentText>
							Enter {textContent} Remarks
						</DialogContentText>
						<TextField
							id="remarks"
							name="Remarks"
							label="Add Remarks"
							variant="outlined"
							type="text"
							value={remarks}
							onChange={remarksInputHandler}
							fullWidth
						/>
					</DialogContent>
					<DialogActions>
						<Button
							variant="outlined"
							onClick={closeRemarksModalHandlerForSingleInwarding}
							color="secondary"
						>
							Cancel
						</Button>
						<Button
							onClick={handleSingleInwardingPayment}
							variant="contained"
							color="primary"
							style={{ background: "#2b7636", margin: 5 }}
						>
							Submit
						</Button>
					</DialogActions>
				</Dialog>
			</div>

			{/* Raise Payment Request Button */}
			{/*
            <Button
                onClick={openRaisePaymentRequestModal}
                variant="contained"
                color="primary"
                style={{ background: "#2b7636", margin: 5 }}
            >
                Raise Payment
            </Button>
            */}
		</div>
	);
};

export default connect(null, { setLoading, setSnackInfo })(
	PaymentRequestApproval
);